export default [
  {
    title: "مسیر یادگیری",
    icon: "TrelloIcon",
    route: "profile-road-map",
  },
  {
    title: "دوره های آموزشی",
    icon: "BookOpenIcon",
    route: "shop",
  },
  {
    title: "دوره های من",
    icon: "ClipboardIcon",
    route: "profile-courses",
  },
  {
    title: "تمرین ها",
    icon: "FileTextIcon",
    route: "profile-exercises",
  },
  {
    title: "فاکتور ها",
    icon: "ClipboardIcon",
    route: "profile-paid-items",
  },
  {
    title: "جریمه ها",
    icon: "FileTextIcon",
    route: "profile-penalties",
  },
  {
    title: "تراکنش ها",
    icon: "TrelloIcon",
    route: "profile-transactions",
  },
  {
    title: "ویرایش مشخصات",
    icon: "EditIcon",
    route: "profile-edit",
  },
];
